import React, { useEffect, useState } from "react";
import "./RightNav.css";
import useAuth, { authData } from "../../context/AuthProvider";
import { Box, Badge, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip, Typography } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import MenuIcon from '@mui/icons-material/Menu';
import { ReactComponent as InboxIcon } from '../../assets/icons/InboxIcon.svg';
import { ReactComponent as FolderPlusIcon } from '../../assets/icons/FolderPlusIcon.svg';
import { ReactComponent as DocumentIcon } from '../../assets/icons/DocumentIcon.svg';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import { ReactComponent as SettingsIcon } from '../../assets/icons/SettingsIcon.svg';
import { ReactComponent as ArrowCircleIcon } from '../../assets/icons/ArrowCircleIcon.svg';
import { ReactComponent as InfoIcon } from '../../assets/icons/InfoIcon.svg';
import { ReactComponent as ExitIcon } from '../../assets/icons/ExitIcon.svg';
import { TbExternalLink } from "react-icons/tb";

import Swal from "sweetalert2";
import { apiClient } from "../../helper/api";
import { SvgIcon } from '../Icons/SvgIcon';
import { useNavigate } from 'react-router-dom';
import { AppFlags } from "../../helper/config";
import { StateInformationPortalUrl, LicensingPortalUrl } from '../../Constants';
import { AppRoutes } from "../../helper/appRoutes";
import { CLIENT_HOME_ROLES, hasAnyRole } from "../../helper/userRoles";
import { RiSearchLine } from "react-icons/ri";
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useInboxUnreadCount } from '../Icons/InboxNotificationBell';
import { EmailSettingsIcon } from "../Icons/EmailSettingsIcon";
import {
  DEFAULT_PROFILE_PICTURE_PATH,
  customProfileAvatarImageStyle,
  getProfileAvatarContainerStyle,
  getProfileAvatarImageStyle,
  resolveProfilePictureUrl,
} from "../../helper/profilePicture";
import { TbFiles, TbInbox, TbUser, TbCircleCheck, TbReport, TbBook, TbSettings, TbClipboardList, TbChevronRight } from "react-icons/tb";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

var formData = new FormData();
interface Iprops {

  handleClose: () => void,
  Open: boolean,
}
interface ProfilePictureModalProps {
  open: boolean;
  onClose: () => void;
  currentPicture: string;
  onUpdatePicture: (newPicture: string) => void;

}
const ProfilePictureModal: React.FC<ProfilePictureModalProps> = ({
  open,
  onClose,
  currentPicture,
  onUpdatePicture,

}) => {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      formData.delete('image');
      formData.append('image', file);
      setSelectedImage(file);
    }
  };

  const [loading, setloading] = useState(false);
  const handleUpload = () => {
    if (selectedImage) {
      setloading(true);
      const objectURL = URL.createObjectURL(selectedImage);
      // onUpdatePicture(objectURL);
      //Simulate server upload
      setTimeout(() => {
        onUpdatePicture(objectURL);
        setloading(false);
      }
        , 6000
      );

    }
  };
  const handleCloseImage = () => {
    setSelectedImage(null);
    formData.delete('image');
    onClose();
  };


  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          width: "90%",
          maxWidth: 440,
          borderRadius: 2,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          overflow: "hidden",
        },
      }}
    >
      {loading && <LinearProgress sx={{ flexShrink: 0 }} />}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          py: 2,
          px: 2.5,
          background: "linear-gradient(135deg, #0d4a63 0%, #15607a 100%)",
          color: "common.white",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          <AccountCircleOutlinedIcon sx={{ fontSize: 28, opacity: 0.95 }} />
          <Typography component="span" variant="h6" sx={{ fontWeight: 700, fontSize: "1.05rem" }}>
            Edit Profile Picture
          </Typography>
        </Box>
        <IconButton
          onClick={handleCloseImage}
          aria-label="Close"
          size="small"
          sx={{ color: "common.white", "&:hover": { bgcolor: "rgba(255,255,255,0.15)" } }}
        >
          <CloseOutlinedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          bgcolor: "grey.50",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: 3,
          pb: 2,
          px: 3,
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ my: 2.5, maxWidth: 320 }}>
          Choose a square image for the best result. JPG or PNG recommended.
        </Typography>
        <Box
          sx={{
            width: 280,
            maxWidth: "100%",
            mb: 0.5,
            mx: "auto",
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: "100%",
              aspectRatio: "1",
              borderRadius: "50%",
              border: "3px solid",
              borderColor: "grey.200",
              bgcolor: "grey.100",
              boxShadow: (theme) =>
                `0 6px 28px rgba(0,0,0,0.1), 0 0 0 1px ${theme.palette.divider}, 0 0 0 5px rgba(32, 153, 210, 0.1)`,
              overflow: "hidden",
              position: "relative",
              transition: "transform 0.22s ease, box-shadow 0.22s ease",
              ...(!selectedImage
                ? getProfileAvatarContainerStyle(currentPicture)
                : {}),
              "&:hover": {
                transform: "scale(1.02)",
                boxShadow: (theme) =>
                  `0 10px 32px rgba(0,0,0,0.14), 0 0 0 1px ${theme.palette.grey[300]}, 0 0 0 6px rgba(32, 153, 210, 0.16)`,
              },
            }}
          >
            <img
              src={selectedImage ? URL.createObjectURL(selectedImage) : currentPicture}
              alt=""
              style={
                selectedImage
                  ? customProfileAvatarImageStyle
                  : getProfileAvatarImageStyle(currentPicture)
              }
            />
          </Box>
          <Tooltip title="Upload a new photo" placement="left" arrow>
            <IconButton
              component="label"
              aria-label="Choose profile photo"
              sx={{
                position: "absolute",
                bottom: 5,
                right: 5,
                width: 50,
                height: 50,
                bgcolor: "#2099d2",
                color: "#fff",
                boxShadow: "0 3px 14px rgba(32, 153, 210, 0.5)",
                border: "3px solid #fff",
                "&:hover": {
                  bgcolor: "#1a87ba",
                  transform: "scale(1.06)",
                  boxShadow: "0 4px 18px rgba(32, 153, 210, 0.55)",
                },
                transition: "transform 0.18s ease, background-color 0.18s ease, box-shadow 0.18s ease",
              }}
            >
              <CameraAltIcon sx={{ fontSize: 26 }} />
              <input
                accept="image/*"
                style={{ display: "none" }}
                id="profile-picture-upload-home"
                type="file"
                onChange={handleFileChange}
              />
            </IconButton>
          </Tooltip>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, mb: 0.5, maxWidth: 280, lineHeight: 1.5 }}>
          Tap the camera button to choose an image. Preview updates before you save.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: 2.5,
          py: 2,
          borderTop: "1px solid",
          borderColor: "grey.200",
          bgcolor: "grey.100",
          justifyContent: "flex-end",
          gap: 1.5,
        }}
      >
        <Button
          variant="outlined"
          onClick={handleCloseImage}
          startIcon={<CloseOutlinedIcon />}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={!selectedImage || loading}
          startIcon={<SaveOutlinedIcon />}
          sx={{ bgcolor: "#2099d2", "&:hover": { bgcolor: "#1a87ba" } }}
        >
          {loading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};


type PartnerItem = { partnersId: string; customerName: string };

const NavInboxItem: React.FC = () => {
  const { user } = useAuth();
  const unreadCount = useInboxUnreadCount();
  const showInbox =
    user?.userRoles?.split(',').includes('Client Admin') ||
    user?.userRoles?.split(',').includes('Client Processors') ||
    user?.userRoles?.split(',').includes('State Reporter');
  if (!showInbox) return null;
  return (
    <li className="mb-2">
      <a
        href={AppRoutes.inbox}
        className={`px-4 py-3 d-flex text-decoration-none align-items-center ${window.location.pathname === AppRoutes.inbox ? 'active' : ''}`}
        title="Inbox"
      >
        <Badge
          color="error"
          invisible={unreadCount === 0}
          badgeContent={unreadCount}
          sx={{
            flexShrink: 0,
            marginRight: '12px',
            '& .MuiBadge-badge': {
              top: 2,
              right: unreadCount > 9 ? 22 : 18,
              transform: 'scale(1) translate(35%, -50%)',
              transformOrigin: '100% 0%',
            },
          }}
        >
          <TbInbox size={22} color="currentColor" strokeWidth={1} style={{ display: 'block' }} />
        </Badge>
        Inbox
      </a>
    </li>
  );
};

export const CustomerHomeRightNav: React.FC<Iprops> = ({ handleClose, Open }) => {
  const { user, logout, isDiligentSearchUser, hasAnyDiligentPartner } = useAuth();
  const navigate = useNavigate();

  const token = user?.token;
  const [modalOpen, setModalOpen] = useState(false);

  const [userPartners, setUserPartners] = useState<PartnerItem[]>([]);

  const handleLogout = () => {
    Swal.fire({
        title: 'Log Out',
        text: "Are you sure you want to log out?",
        showCancelButton: true,
        confirmButtonColor: '#02A4E3',
        cancelButtonColor: '#d33',
        customClass: 'logout-popup',
        // iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-power" viewBox="0 0 16 16"> \
                    <path d="M7.5 1v7h1V1z"/> \
                    <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812"/> \
                  </svg>',
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
        navigate(AppRoutes.login); 
        return;
      }
    })
  };  

  useEffect(() => {
    if (Open) fetchUserPartners();
  }, [Open]);

  const fetchUserPartners = async () => {
    // Fetch partners or any other data if needed when modal opens
    if (!Open) return;

    apiClient(`/Customer/getPartnersList`, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      })
    })
      .then(responseJson => {
        if (!responseJson) return;

        const fetched: PartnerItem[] = (responseJson.data || [])
          .map((p: any) => ({
            partnersId: String(p.partnersId ?? p.PartnersId ?? ''),
            customerName: p.customerName ?? p.CustomerName ?? ''
          }))
          .filter((p: PartnerItem) => !!p.partnersId);

        const sorted = Object.values(fetched).sort((a, b) => a.customerName.localeCompare(b.customerName, undefined, { sensitivity: 'base' }));
        setUserPartners(sorted);
        console.log('Fetched partners:', sorted);
      })
      .catch(err => console.error('Error fetching partners:', err));

  }

  const handleModalOpen = () => {
    setModalOpen(true);
  };
  const handleExitClick = () => {
    Swal.fire({
      title: 'Log Out',
      text: "Are you sure you want to log out?",
      showCancelButton: true,
      confirmButtonColor: '#02A4E3',
      cancelButtonColor: '#d33',
      customClass: 'logout-popup',
      // iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-power" viewBox="0 0 16 16"> \
                      <path d="M7.5 1v7h1V1z"/> \
                      <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812"/> \
                    </svg>',
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
        navigate(AppRoutes.login);
        return;
      }
    })
  };


  const handleModalClose = () => {
    setModalOpen(false);
  };
  interface UserData {
    userId: number;

  }
  let userStr: authData | undefined = user;

  const [userProfile, setUserProfile] = useState<string>(
    resolveProfilePictureUrl(userStr?.profilePicture)
  );

  const [loading, setloading] = useState(false);

  const handleUpdatePicture = (newPicture: string) => {

    const initValues: UserData = {
      userId: user?.userId ?? 0,

    };
    formData.append("data", JSON.stringify(initValues))
    console.log("finalData", initValues)
    setloading(true);
    apiClient(`/Users/UpdateProfilePicture`, {

      method: "POST",
      headers: new Headers({
        // "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
      body: formData


    })
      .then((res) => {
        if (!res) return
        if (res.resp == 0) {

          // let userStr : authData | undefined =  localStorage.getItem("user");
          // userStr.profilePicture = res.data;
          console.log("profleurl", res.data);
          console.log("loalstorageData", userStr);


          if (userStr != undefined) {
            userStr.profilePicture = res.data
            localStorage.removeItem("user");
            localStorage.setItem("user", JSON.stringify(userStr));
            setUserProfile(res.data);
          }


          Swal.fire({
            title: "Profile Picture Updated Successfully",
            text: "",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>',
            confirmButtonColor: '#02A4E3',
            confirmButtonText: 'OK',
            customClass: {
              confirmButton: 'btn-radius',
              cancelButton: 'btn-radius',
              popup: 'card-radius'
            }
          })
            .then((result) => {
              formData.delete("data");
              formData.delete("image");
              handleModalClose();
            })
        }
        setloading(false);
      })
      .finally(() => {
        setloading(false);
      });

  };

  const fullName = (user?.userFirstName ?? "") + " " + (user?.userLastName ?? "");

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "/assets/dist/js/myscripts.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };

  }, []);

  const handleBackdropClick = () => {
    handleClose();
  };

  const handleCloseNav = () => {
    handleClose();
  };

  return (
    <>
      <div
        role="presentation"
        aria-hidden={Open}
        className={`nav-backdrop ${Open ? "nav-backdrop--hidden" : ""}`}
        onClick={handleBackdropClick}
      />
      <div
        className={`me-n1 bg-dm-light nav-wrapper custom-style-nav nav-panel right-nav-panel ${!Open ? "right-nav-panel--visible" : ""}`}
        style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000 }}
        aria-hidden={Open}
      >
        <div
          className="d-flex justify-content-between align-items-center p-4 border-bottom border-black position-absolute w-100 nav-header"
          style={{ backgroundColor: "#162E3C", zIndex: 5 }}
        >
          <img
            src="/assets/brand/MISC_Brandmark_Primary.png"
            className="align-self-center"
            style={{ width: "34px", height: "35px" }}
            alt="MISC"
          />
          <ul className="ms-auto d-flex mb-0 flex-wrap list-unstyled">
            <li className="px-2">
              <button
                type="button"
                onClick={handleCloseNav}
                className="nav-close-btn border-0 bg-transparent p-0"
                aria-label="Close menu"
                style={{ color: "#fff", cursor: "pointer" }}
              >
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.25 7.75L7.75 23.25M7.75 7.75L23.25 23.25"
                    stroke="currentColor"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </li>
          </ul>
        </div>

        <div className="nav-bar-right-sides h-100 overflow-y-auto" style={{ paddingTop: "110px", paddingBottom: "40px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-between" }}>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  px: 2.5,
                  py: 2,
                  mx: 1.5,
                  mb: 2,
                  borderRadius: "12px",
                  backgroundColor: "rgba(255, 255, 255, 0.06)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                }}
              >
                <Box sx={{ position: "relative" }}>
                <Box
                  onClick={handleModalOpen}
                  sx={{
                    cursor: "pointer",
                    flexShrink: 0,
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "2px solid rgba(255, 255, 255, 0.25)",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                    transition: "border-color 0.2s, box-shadow 0.2s",
                    ...getProfileAvatarContainerStyle(
                      userProfile || DEFAULT_PROFILE_PICTURE_PATH
                    ),
                    // position: "relative",
                    "& .edit-profile-badge": {
                      opacity: 0,
                      transition: "opacity 0.2s ease",
                      pointerEvents: "none",
                    },
                    "&:hover": {
                      borderColor: "rgba(255, 255, 255, 0.5)",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
                      "& .edit-profile-badge": {
                        opacity: 1,
                      },
                    },
                  }}
                >
                  <EditOutlinedIcon className="edit-profile-badge" fontSize="small" sx={{ color: "#fff", position: "absolute", bottom: '-3px', right: '-3px', backgroundColor: "rgba(255, 255, 255, 0.6)", borderRadius: "50%", p: 0.5, zIndex: 1 }} />
                  <Box
                    component="img"
                    src={userProfile || DEFAULT_PROFILE_PICTURE_PATH}
                    alt="Profile"
                    sx={getProfileAvatarImageStyle(userProfile || DEFAULT_PROFILE_PICTURE_PATH)}
                  />
                </Box>
                </Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: 500,
                      color: "rgba(255, 255, 255, 0.75)",
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                      lineHeight: 1.2,
                    }}
                  >
                    Welcome back
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 600,
                      color: "#fff",
                      lineHeight: 1.3,
                    }}
                  >
                    {user?.userFirstName ?? "User"}
                  </Typography>
                </Box>
                <Box sx={{ minWidth: 0, marginLeft: 'auto' }} className="d-block d-md-none">
                    <LogoutOutlinedIcon onClick={handleLogout} sx={{ fontSize: 22, color: "#fff", cursor: "pointer" }} />
                </Box>
              </Box>

              <ProfilePictureModal
                open={modalOpen}
                onClose={handleModalClose}
                currentPicture={userProfile || DEFAULT_PROFILE_PICTURE_PATH}
                onUpdatePicture={handleUpdatePicture}
              />

              <div className="nav-bar-right-sides">
                <ul className="list-unstyled mt-3 navigation" style={{ paddingBottom: "40px" }}>
                  {(user?.userRoles.split(",").includes("Client Admin") ||
                    user?.userRoles.split(",").includes("Client Processors") ||
                    (AppFlags.enableStateReports && user?.userRoles.split(",").includes("State Reporter"))) && (
                      // <li className="mb-2">
                      //   <a
                      //     href={AppRoutes.inbox}
                      //     className="px-4 py-3 d-flex text-decoration-none align-items-center"
                      //     title="Inbox"
                      //   >
                      //     <SvgIcon
                      //       IconComponent={InboxIcon}
                      //       size={22}
                      //       fill="currentColor"
                      //       sx={{ mr: "8px", flexShrink: 0 }}
                      //     />
                      //     Inbox
                      //   </a>
                      // </li>
                      <NavInboxItem />
                  )}
                  {(user?.userRoles.split(",").includes("Client Admin") ||
                    user?.userRoles.split(",").includes("Client Processors")) && (
                      <li className="mb-2">
                        <a
                          href={AppRoutes.client.base}
                          className={`px-4 py-3 d-flex text-decoration-none align-items-center ${window.location.pathname === AppRoutes.client.base ? 'active' : ''}`}
                          title="Filing Queue"
                        >
                          <TbFiles size={22} color="currentColor" strokeWidth={1} className="me-2" />
                          {/* <SvgIcon
                            IconComponent={FolderPlusIcon}
                            size={22}
                            stroke="currentColor"
                            strokeWidth="2.5"
                            fill="none"
                            sx={{ mr: "8px", flexShrink: 0 }}
                          /> */}
                          Filing Queue
                        </a>
                      </li>
                    )}
                  {user?.userRoles.split(",").includes("Client Admin") && (
                      <li className="mb-2">
                        <a
                          href={AppRoutes.client.nonPremiumEndorsements}
                          className={`px-4 py-3 d-flex text-decoration-none align-items-center ${window.location.pathname === AppRoutes.client.nonPremiumEndorsements ? 'active' : ''}`}
                          title="Non-Premium Endorsements"
                        >
                          <TbCircleCheck size={22} color="currentColor" strokeWidth={1} className="me-2" />
                          {/* <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "8px", flexShrink: 0 }}
                          >
                            <path
                              d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm2 16H8v-2h8zm0-4H8v-2h8zm-3-5V3.5L18.5 9z"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14 2V8H20"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg> */}
                          Non-Premium Endorsements
                        </a>
                      </li>
                    )}
                  {AppFlags.enableStateReports &&
                    (user?.userRoles.split(",").includes("Client Admin") ||
                    user?.userRoles.split(",").includes("State Reporter")) && (
                      <li className="mb-2">
                        <a
                          href={AppRoutes.client.stateReports}
                          className={`px-4 py-3 d-flex text-decoration-none align-items-center ${window.location.pathname === AppRoutes.client.stateReports ? 'active' : ''}`}
                          title="State Reports"
                        >
                          <TbReport size={22} color="currentColor" strokeWidth={1} className="me-2" />
                          {/* <SvgIcon
                            IconComponent={DocumentIcon}
                            size={22}
                            stroke="currentColor"
                            strokeWidth="2.5"
                            fill="none"
                            sx={{ mr: "8px", flexShrink: 0 }}
                          /> */}
                          State Reports
                        </a>
                      </li>
                    )}
                  {hasAnyRole(user?.userRoles, CLIENT_HOME_ROLES) && (
                    <li
                      className={`mb-2 has-submenu1 ${window.location.pathname === AppRoutes.client.monthlyAccountPerformance ? 'active' : ''}`}
                    >
                      <a
                        href="#"
                        className={`px-4 py-3 d-flex text-decoration-none align-items-center ${window.location.pathname === AppRoutes.client.monthlyAccountPerformance ? 'active' : ''}`}
                        title="Reporting"
                      >
                        <TbClipboardList size={22} color="currentColor" strokeWidth={1} className="me-2" />
                        Reporting
                        <TbChevronRight className="ms-auto arrow-right" />
                      </a>
                      <ul
                        className="list-unstyled sub-menu1 mx-3 ms-4 pb-2"
                        style={{
                          display: window.location.pathname === AppRoutes.client.monthlyAccountPerformance ? 'block' : '',
                        }}
                      >
                        <li>
                          <a
                            href={AppRoutes.client.monthlyAccountPerformance}
                            className={`px-3 py-3 d-block text-decoration-none ${window.location.pathname === AppRoutes.client.monthlyAccountPerformance ? 'active' : ''}`}
                            title="Monthly Account Report"
                          >
                            Monthly Account Report
                          </a>
                        </li>
                      </ul>
                    </li>
                  )}
                  {isDiligentSearchUser === true &&
                    hasAnyDiligentPartner === true &&
                    (user?.userRoles.split(",").includes("Client Admin") ||
                      user?.userRoles.split(",").includes("Diligent Search User")) && (
                    <li className="mb-2">
                      <a
                        href={AppRoutes.home.diligentSearchLibrary}
                        className={`px-4 py-3 d-flex text-decoration-none ${window.location.pathname === AppRoutes.home.diligentSearchLibrary ? 'active' : ''}`}
                        title="Diligent Search Library"
                      >
                        <TbBook size={22} color="currentColor" strokeWidth={1} className="me-2" />
                        Diligent Search Library
                      </a>
                    </li>
                  )}
                  {/* {(user?.userRoles.split(",").includes("Client Admin")) && (
                      <li className="mb-2">
                        <a
                          href={AppRoutes.client.clientUsers}
                          className={`px-4 py-3 d-flex text-decoration-none align-items-center ${window.location.pathname === AppRoutes.client.clientUsers ? 'active' : ''}`}
                          title="Settings"
                        >
                          <SvgIcon
                            IconComponent={SettingsIcon}
                            size={22}
                            fill="currentColor"
                            sx={{ mr: "8px", flexShrink: 0 }}
                          />
                          Settings
                        </a>
                      </li>
                    )} */}
                  {/* <li className="mb-2 d-block d-md-none">
                    <Box
                      component="span"
                      className="px-4 py-3 d-flex align-items-center"
                      onClick={() => setNotificationPopupOpen(!notificationPopupOpen)}
                      sx={{
                        color: "rgba(146, 186, 207, 0.7)",
                        cursor: "pointer",
                        borderRadius: "8px",
                        marginLeft: "18px",
                        marginRight: "8px",
                        '&:hover': {
                          backgroundColor: 'rgb(32 153 210 / 20%)',
                          color: '#97deff',
                        },
                      }}
                    >
                      <EmailSettingsIcon fontSize={24} variant="currentColor" />
                      <span className="ms-2">Email Notification Settings</span>
                    </Box>
                  </li> */}
                  {(user?.userRoles.split(",").includes("Customer Admin")
                  ) && user?.partnerName === "Intrepid Direct Insurance Agency LLC" && (
                    <React.Fragment>
                      <li className="mb-2">
                        <a
                            href={AppRoutes.customerOpenTaxReport}
                            className={`px-4 py-3 d-flex text-decoration-none align-items-center ${window.location.pathname === AppRoutes.customerOpenTaxReport ? 'active' : ''}`}
                            title="OTR Upload"
                        >
                            <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "8px", flexShrink: 0 }}
                          >
                            <path
                              d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15ZM4 15V22"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          OTR Upload
                        </a>
                      </li>
                    </React.Fragment>
                  )}
                </ul>
              </div>
            </Box>
            <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid rgba(255, 255, 255, 0.12)" }}>
              <Typography
                sx={{
                  px: 2,
                  mb: 1.5,
                  fontSize: "0.6875rem",
                  fontWeight: 600,
                  color: "rgba(255, 255, 255, 0.55)",
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                }}
              >
                External portals
              </Typography>
              <ul className="list-unstyled mb-0 navigation">
                {user?.isLicensingUser ? (
                  <li className="mb-2">
                    <a
                      href={LicensingPortalUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Go to Licensing Portal"
                      className={`px-4 py-3 d-flex text-decoration-none align-items-center ${window.location.pathname === LicensingPortalUrl ? 'active' : ''}`}
                    >
                      <SvgIcon
                        IconComponent={ArrowCircleIcon}
                        size={22}
                        stroke="currentColor"
                        strokeWidth="2.5"
                        sx={{ mr: "8px", flexShrink: 0 }}
                      />
                      Go to Licensing Portal
                    </a>
                  </li>
                ) : (null)}
              {/* </ul> */}
              {/* {isDiligentSearchUser === true &&
                hasAnyDiligentPartner === true &&
                (user?.userRoles.split(",").includes("Client Admin") ||
                  user?.userRoles.split(",").includes("Diligent Search User")) && (
                <li className="mb-2">
                  <a
                    href={AppRoutes.home.diligentSearchLibrary}
                    className={`px-4 py-3 d-flex text-decoration-none text-white ${window.location.pathname === AppRoutes.home.diligentSearchLibrary ? 'active' : ''}`}
                    title="Diligent Search Library"
                  >
                    <LocalLibraryIcon
                      sx={{ fontSize: 24, color: '#02A4E3', mr: '15px' }}
                    />
                    Diligent Search Library
                  </a>
                </li>
              )} */}
              {(user?.userRoles.split(",").includes("Client Admin") ||
                user?.userRoles.split(",").includes("Client Processors") ||
                (AppFlags.enableStateReports && user?.userRoles.split(",").includes("State Reporter")) ||
                user?.userRoles.split(",").includes("Diligent Search User") ||
                user?.userRoles.split(",").includes("Client Accounting") ||
                user?.userRoles.split(",").includes("Customer User")) && (
                <li className="mb-2 settings-nav">
                  <a
                    href={AppRoutes.client.notificationPreferences}
                    className={`px-4 py-3 d-flex text-decoration-none text-white ${window.location.pathname === AppRoutes.client.notificationPreferences ? 'active' : ''}`}
                    title="Settings"
                  >
                    <TbSettings size={22} color="currentColor" strokeWidth={1} className="me-2" />
                    Settings
                  </a>
                </li>
              )}
              {(user?.userRoles.split(",").includes("Client Admin") ||
                user?.userRoles.split(",").includes("Client Processors") ||
                (AppFlags.enableStateReports && user?.userRoles.split(",").includes("State Reporter")) ||
                user?.userRoles.split(",").includes("Diligent Search User") ||
                user?.userRoles.split(",").includes("Client Accounting") ||
                user?.userRoles.split(",").includes("Customer User")) && (
                  <React.Fragment>
                    {user?.userRoles.split(",").includes("Client Admin") && (
                      <li className="mb-2">
                        <a
                          href={AppRoutes.client.clientUsers}
                          className={`px-4 py-3 d-flex text-decoration-none text-white ${window.location.pathname === AppRoutes.client.clientUsers ? 'active' : ''}`}
                          title="Users"
                        >
                          <TbUser size={22} color="currentColor" strokeWidth={1} className="me-2" />
                          Users
                        </a>
                      </li>
                  )}
                  </React.Fragment>
                )}
              {(user?.userRoles.split(",").includes("Customer Admin")
              ) && user?.partnerName === "Intrepid Direct Insurance Agency LLC" && (
                <React.Fragment>
                  <li className="mb-2">
                    <a
                        href={AppRoutes.customerOpenTaxReport}
                        className={`px-4 py-3 d-block text-decoration-none text-white ${window.location.pathname === AppRoutes.customerOpenTaxReport ? 'active' : ''}`}
                        title="OTR Upload"
                    >
                        
                        <SvgIcon
                          IconComponent={ArrowCircleIcon}
                          size={22}
                          stroke="currentColor"
                          strokeWidth="2.5"
                          sx={{ mr: "8px", flexShrink: 0 }}
                        />
                        How to become a Licensing Client?
                      
                    </a>
                  </li>
                </React.Fragment>
                )}
                {user?.isSIPAccess ? (
                  <li className="mb-2">
                    <a
                      href={StateInformationPortalUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Go to State Information Portal"
                      className="px-4 py-3 d-flex text-decoration-none align-items-center"
                    >
                      <SvgIcon
                        IconComponent={InfoIcon}
                        size={22}
                        stroke="currentColor"
                        strokeWidth="2.5"
                        sx={{ mr: "8px", flexShrink: 0 }}
                      />
                      Go to State Information Portal
                      <TbExternalLink size={18} color="currentColor" strokeWidth={1} className="ms-2"/>
                    </a>
                  </li>
                ) : (
                  <li className="mb-2">
                    <Tooltip
                      title={
                        <span>
                          To become an SIP subscriber, please contact{" "}
                          <a href="mailto:miscfilings@morrisisc.com" style={{ color: "#90caf9" }}>
                            miscfilings@morrisisc.com
                          </a>
                        </span>
                      }
                      arrow
                      placement="right"
                      componentsProps={{ tooltip: { sx: { fontSize: "0.875rem" } } }}
                    >
                      <Box
                        component="span"
                        className="px-4 py-3 d-flex align-items-center"
                        sx={{
                          color: "rgba(146, 186, 207, 0.7)",
                          cursor: "default",
                          borderRadius: "8px",
                          marginLeft: "18px",
                          marginRight: "8px",
                        }}
                      >
                        <SvgIcon
                          IconComponent={InfoIcon}
                          size={22}
                          stroke="currentColor"
                          strokeWidth="2.5"
                          sx={{ mr: "8px", flexShrink: 0 }}
                        />
                        How to become an SIP Subscriber?
                      </Box>
                    </Tooltip>
                  </li>
                )}
              </ul>
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
};
